import React, { useState, useEffect } from 'react';
import { ArrowDown } from 'lucide-react';

const AgentStateFlow = ({ steps, autoPlay = true, speed = 2000 }) => {
  const [activeStep, setActiveStep] = useState(0);

  useEffect(() => {
    if (!autoPlay) return;

    const interval = setInterval(() => {
      setActiveStep((prev) => (prev + 1) % steps.length);
    }, speed);

    return () => clearInterval(interval);
  }, [autoPlay, speed, steps.length]);

  return (
    <div className="flex flex-col items-center space-y-4 py-8">
      {steps.map((step, index) => (
        <React.Fragment key={index}>
          <div
            className={`w-full max-w-md p-6 rounded-xl border-2 transition-all duration-500 ${
              index === activeStep
                ? 'bg-blue-500/20 border-blue-500 scale-105 shadow-lg shadow-blue-500/50'
                : 'bg-gray-800/50 border-gray-700'
            }`}
          >
            <div className="flex items-center justify-between">
              <div className="flex-1">
                <div
                  className={`text-sm font-mono mb-1 ${
                    index === activeStep ? 'text-blue-400' : 'text-gray-500'
                  }`}
                >
                  {step.action}
                </div>
                <div
                  className={`text-sm ${
                    index === activeStep ? 'text-white' : 'text-gray-400'
                  }`}
                >
                  {step.description}
                </div>
              </div>
              {index === activeStep && (
                <div className="ml-4">
                  <div className="w-3 h-3 bg-blue-500 rounded-full animate-pulse" />
                </div>
              )}
            </div>
          </div>
          {index < steps.length - 1 && (
            <ArrowDown
              className={`${
                index === activeStep ? 'text-blue-500' : 'text-gray-600'
              } transition-colors duration-300`}
              size={24}
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default AgentStateFlow;